import template from './settings-sidebar.html';
import controller from './settings-sidebar.controller';

let settingsSidebarComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default settingsSidebarComponent;



// WEBPACK FOOTER //
// ./client/common/settings-sidebar/settings-sidebar.component.js